import React from "react";
import GheeIcon from "../../assets/ghee.png";
import MilkIcon from "../../assets/milk.svg";
import PannerIcon from "../../assets/panner.png";

export default function Products() {
  const products = [
    {
      icon: (
        <div className="iconContainer">
          <img src={MilkIcon} alt="Fresh Cow Milk" className="gheeIcon" />
        </div>
      ),
      title: "Fresh Cow Milk",
      description:
        "100% organic cow milk — fresh, pure, and unprocessed. Delivered daily from healthy, pasture-raised cows.",
    },
    {
      icon: (
        <div className="iconContainer">
          <img src={PannerIcon} alt="Paneer" className="gheeIcon" />
        </div>
      ),
      title: "Paneer",
      description:
        "Organic paneer made from rich, farm-fresh milk. Soft, wholesome, and crafted with care — just the way nature intended.",
    },
    {
      icon: (
        <div className="iconContainer">
          <img src={GheeIcon} alt="Ghee" className="gheeIcon" />
        </div>
      ),
      title: "Ghee",
      description:
        "Traditional organic ghee, slow-cooked from pure cow milk. Naturally rich in aroma, flavor, and goodness.",
    },
  ];

  return (
    <section id="products" className="productsSection">
      <div className="productsContainer">
        <h2 className="productsTitle">Our Products</h2>

        <div className="productsGrid">
          {products.map((product, index) => (
            <div key={index} className="productCard">
              <div className="productContent">
                <div className="productIcon">{product.icon}</div>
                <h3 className="productTitle">{product.title}</h3>
                <p className="productDescription">{product.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
